import Vue from "vue";
import Router from "vue-router";
import routes from "@/router/routes/public.js";

Vue.use(Router);

let router = new Router({
    mode : "history",
    routes: [
    {
        path: "/",
        name: "Home"
    }
    ].concat(routes)
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    if(to.path == '/') {
        return next({
            path: "/homepage"
        });
    }else{
        next();
    }

});

export default router;
